interface UrlMatcher {
  url: string;
  regex: RegExp;
  tier: number | null;
  flow?: string;
}

export const URL_MATCHERS: UrlMatcher[] = [
  {
    url: "/api/v2/vessels/VESSEL_NAME/ctos",
    tier: 0,
    regex: /\/api\/v2\/vessels\/[a-zA-Z0-9_.-]+\/ctos(\/|\?.*)?$/,
  },
  {
    url: "/api/reef/api/v2/vessels/VESSEL_NAME/ctos/status",
    tier: 0,
    regex:
      /\/api\/v2\/vessels(\/([a-zA-Z0-9_.-]+))\/ctos(\/(status)?(\/|\?.*)?)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/contingency-plan",
    tier: 2,
    regex:
      /\/api\/v2\/vessels(\/([a-zA-Z0-9_.-]+))(\/(contingency-plan)?(\/|\?.*)?)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/recommendation-summary",
    tier: 0,
    regex:
      /\/api\/v2\/vessels(\/([a-zA-Z0-9_.-]+))(\/(recommendation-summary)?(\/|\?.*)?)?$/,
  },
  {
    url: "/api/v2/vessel",
    tier: 0,
    regex: /\/api\/v2(\/(vessel)?(\/|\?.*)?)?$/,
  },
  {
    url: "/user/USER_ID/permission",
    flow: "login",
    tier: 0,
    regex: /\/api\/v2\/user\/[a-zA-Z0-9_.-]+\/permission(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/cto-summary",
    tier: 0,
    regex: /\/api\/v2(\/(cto-summary)?(\/|\?.*)?)?$/,
  },
  {
    url: "/api/v2/sce/summary",
    tier: 0,
    regex: /\/v2\/sce(\/(summary)?(\/|\?.*)?)?$/,
  },
  {
    url: "/api/v2/last_db_update",
    tier: 3,
    regex: /\/api\/v2(\/(last_db_update)?(\/|\?.*)?)?$/,
  },
  {
    url: "/api/v2/user/me",
    flow: "login",
    tier: 0,
    regex: /\/api\/v2(\/(user\/me)?(\/|\?.*)?)?$/,
  },
  {
    url: "/api/v2/mah/summary",
    tier: 0,
    regex: /api\/v2\/mah(\/summary)?(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/recommendation-summary",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/recommendation-summary(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID",
    tier: 0,
    regex: /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))?$/,
  },
  {
    url: "/api/v3/vessel/VESSEL_NAME/cto/CTO_ID/recommendation",
    tier: 0,
    regex:
      /api\/v3\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/recommendation(\/|\?.*)?$/,
  },
  {
    url: "/api/v3/vessel/VESSEL_NAME/tag/status",
    tier: 0,
    regex: /api\/v3\/vessel(\/([a-zA-Z0-9_.-]+))\/tag(\/status)?(\/|\?.*)?$/,
  },
  {
    url: "/api/v3/vessel/VESSEL_NAME/cto/CTO_ID/evaluation",
    tier: 0,
    regex:
      /api\/v3\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/evaluation(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/user/search",
    tier: 0,
    regex: /api\/v2\/user(\/search)?(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/contingency-plan",
    tier: 2,
    regex: /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/contingency-plan(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/recommendation",
    tier: 0,
    regex: /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/recommendation(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/recommendations",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/recommendations(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/export",
    tier: 1,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/export(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/reassessment",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/reassessment(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/tag/status",
    tier: 0,
    regex: /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/tag(\/status)?(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto",
    tier: 0,
    regex: /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/evaluation",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/evaluation(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/tag/summary",
    tier: 0,
    regex: /api\/v2\/tag(\/summary)?(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/initiation",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/initiation(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/close",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/close(\/|\?.*)?$/,
  },
  {
    url: "/api/v3/vessel/VESSEL_NAME/cto/CTO_ID/closure",
    tier: 0,
    regex:
      /api\/v3\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/closure(\/|\?.*)?$/,
  },
  {
    url: "/api/v3/vessel/VESSEL_NAME/cto/CTO_ID/closure/approve",
    tier: 0,
    regex:
      /api\/v3\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/closure\/approve(\/|\?.*)?$/,
  },
  {
    url: "/api/v3/vessel/VESSEL_NAME/cto/CTO_ID/review",
    tier: 0,
    regex:
      /api\/v3\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/review(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/user/permission",
    tier: 0,
    regex: /api\/v2\/user(\/permission)?(\/|\?.*)?$/,
  },
  { url: "/api/v2/group", tier: 0, regex: /api\/v2\/group(\/|\?.*)?$/ },
  {
    url: "/api/v2/vessel/VESSEL_NAME/mah/status",
    tier: 1,
    regex: /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/mah(\/status)?(\/|\?.*)?$/,
  },
  {
    url: "/api/v3/vessel/VESSEL_NAME/cto/CTO_ID/initiation",
    tier: 0,
    regex:
      /api\/v3\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/initiation(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/approval",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/approval(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/review",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/review(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/file/FILE_ID",
    tier: 2,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/file(\/([a-zA-Z0-9_.-]+))?(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/file",
    tier: 1,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/file(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/closure",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/closure(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/verification",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/verification(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/recommendation/ID/implementation",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/recommendation(\/([a-zA-Z0-9_.-]+)\/implementation)?(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/recommendation/ID/extend",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/recommendation(\/([a-zA-Z0-9_.-]+)\/extend)?(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/wo/status",
    tier: 2,
    regex: /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/wo(\/status)?(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/sce/status",
    tier: 3,
    regex: /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/sce(\/status)?(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/sces/status/for-mah",
    tier: 2,
    regex: /api\/v2\/sces\/status\/for-mah(\/|\?.*)?$/,
  },
  // New endpoints from Notion
  {
    url: "/api/v2/hc/summary",
    tier: 0,
    regex: /api\/v2\/hc(\/summary)?(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/mah/MAH_CODE/barriers",
    tier: 1,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/mah(\/([a-zA-Z0-9_.-]+))\/barriers(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/barrier/BARRIER_CODE/sces",
    tier: 1,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/barrier(\/([a-zA-Z0-9_.-]+))\/sces(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/initiation/approve",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/initiation\/approve(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/review/approve",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/review\/approve(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/extend-date",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/extend-date(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/cto/CTO_ID/mitigation_protocol/assign",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/cto(\/([a-zA-Z0-9_.-]+))\/mitigation_protocol\/assign(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/contingency-plan/CODE",
    tier: 2,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/contingency-plan(\/([a-zA-Z0-9_.-]+))(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/group/GROUP_ID",
    tier: 0,
    regex: /api\/v2\/group(\/([a-zA-Z0-9_.-]+))(\/history)?(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/permission",
    tier: 0,
    regex: /api\/v2\/permission(\/|\?.*)?$/,
  },
  { url: "/api/v2/AD/users", tier: 0, regex: /api\/v2\/AD\/users(\/|\?.*)?$/ },
  {
    url: "/auth/active_users",
    tier: 0,
    regex: /\/auth\/active_users(\/|\?.*)?$/,
  },
  {
    url: "/auth/user/USER_ID",
    tier: 0,
    regex: /\/auth\/user(\/([a-zA-Z0-9_.-]+))?(\/|\?.*)?$/,
  },
  {
    url: "/api/v2/vessel/VESSEL_NAME/mah/MAH_CODE/bowtie",
    tier: 0,
    regex:
      /api\/v2\/vessel(\/([a-zA-Z0-9_.-]+))\/mah(\/([a-zA-Z0-9_.-]+))\/bowtie(\/|\?.*)?$/,
  },
  { url: "/api/v2/support", tier: 0, regex: /\/api\/v2\/support(\/|\?.*)?$/ },
];

export const normalizeUrl = (url: string | undefined | null): string | null => {
  if (!url) return null;
  const match = URL_MATCHERS.find(({ regex }) => regex.test(url));
  return match?.url ?? url;
};
